import PropTypes from "prop-types";
import React from "react";

type StatusBadgeProps = {
  status: string;
};

const variant = {
  red: "text-red-600 bg-red-100",
  orange: "text-orange-600 bg-orange-200",
  yellow: "text-yellow-600 bg-yellow-100",
  green: "text-green-600 bg-green-100",
  blue: "text-blue-600 bg-blue-100",
  gray: "text-gray-600 bg-gray-100",
}

const StatusBadge = ({ status }: StatusBadgeProps) => {
  const statusFormat: { [key: string]: string } = {
    Active: variant.green,              // User
    Suspended: variant.orange,          // User
    Deactivated: variant.red,           // User
    "Invitation sent": variant.yellow,  // User
    Dormant: variant.red,               // Community
    Approved: variant.green,            // Request
    Pending: variant.yellow,            // Request
    Rejected: variant.red,              // Request
    Submitted: variant.green,           // Transaction
    Cancelled: variant.red,             // Transaction
    Amended: variant.blue,              // Transaction
    Queried: variant.yellow,            // Transaction
  };

  return (
    <div
      className={`inline-block px-3 py-1 text-xs font-semibold rounded-full ${
        statusFormat[status] || variant.gray
      }`}
    >
      {status}
    </div>
  );
};

// Define PropTypes for the component
StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusBadge;
